import PropTypes from "prop-types";
import React, { useEffect, Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { multilanguage, loadLanguages } from "redux-multilanguage";
import { connect } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";

// home pages
const Home = lazy(() => import("./pages/home/Home"));
// about us pages
const AboutUs = lazy(() => import("./pages/about-us/AboutUs"));
// product pages
const ProductPage = lazy(() => import("./pages/product/Product"));
const ProductDetail = lazy(() => import("./pages/product-detail/ProductDetail"));
//hardware
const Hardware = lazy(() => import("./pages/hardware/Hardware"));
//testimonial
const Testimonial = lazy(() => import("./pages/testimonial/Testimonial"));
//contact
const Contact = lazy(() => import("./pages/contact-us/ContactUs"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = (props) => {
  useEffect(() => {
    props.dispatch(
      loadLanguages({
        languages: {
          en: require("./translations/english.json"),
          fn: require("./translations/french.json"),
          de: require("./translations/germany.json")
        }
      })
    );
  });

  return (
    <ToastProvider placement="bottom-left">
      <BreadcrumbsProvider>
        <Router>
          <ScrollToTop>
            <Suspense
              fallback={
                <div className="flone-preloader-wrapper">
                  <div className="flone-preloader">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              }
            >
              <Switch>
                {/* Homepages */}
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={Home}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/about-us"}
                  component={AboutUs}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/product"}
                  component={ProductPage}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/product/detail-product"}
                  component={ProductDetail}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/hardware"}
                  component={Hardware}
                />
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/testimonial"}
                  component={Testimonial}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/contact"}
                  component={Contact}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/not-found"}
                  component={NotFound}
                />

                <Route exact component={NotFound} />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </Router>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};

App.propTypes = {
  dispatch: PropTypes.func
};

export default connect()(multilanguage(App));
